export class SkyLinkRecordsFieldsClearFieldsAction {
  constructor(
    public key: string
  ) {
  }
}
